// extracted by mini-css-extract-plugin
module.exports = {"blockGraphs":"verticalGraph_blockGraphs__33ocI","verticalGraph":"verticalGraph_verticalGraph__3jQzi","secondGraph":"verticalGraph_secondGraph__NIuon"};